module.exports = __webpack_public_path__ + "static/media/4980470d-4479-4146-b004-2538d22f9a88.6b907a11.JPG";